import { SxProps, Theme } from "@mui/system";

type Sx = SxProps<Theme>;

export const sxMerge = (innerSx: Sx, outerSx: Sx = []): any => [
  ...(Array.isArray(innerSx) ? innerSx : [innerSx]),
  ...(Array.isArray(outerSx) ? outerSx : [outerSx]),
];
